module.exports = __webpack_public_path__ + "img/HEART-K.fea32498.svg";